import { SiteStructureType_pageCollection_items_childrenpagesCollection_items } from "globalQueries/contentfulTypes/SiteStructureType";
import { URLStructureType_pageCollection_items } from "globalQueries/contentfulTypes/URLStructureType";
import { UrlStructureItem } from "types/UrlStructureItem";

import { SiteStructureItem } from "../types/SiteStructureItem";

export const UrlStructureFactory = (
  array: Array<URLStructureType_pageCollection_items>,
  id: string,
): UrlStructureItem[] => {
  const flatStructure: SiteStructureItem[] = [];
  const urlStructurePageCollectionArray = array?.filter(
    (page: URLStructureType_pageCollection_items) => page?.slug !== "404" && page?.slug !== "500",
  );
  const siteStructureUrls = getFlatStructure(
    urlStructurePageCollectionArray,
    id,
    flatStructure,
    "",
  );
  const newsEventAndReportUrls = getSpecialItemUrls(urlStructurePageCollectionArray);
  const urls = [].concat(siteStructureUrls, newsEventAndReportUrls);
  return urls;
};

const getFlatStructure = (
  array: Array<URLStructureType_pageCollection_items>,
  id: string,
  flatStructure: UrlStructureItem[],
  parentUrl: string,
): UrlStructureItem[] => {
  // eslint-disable-next-line sonarjs/no-unused-collection
  const structureItemChildren: any = [];
  const item: URLStructureType_pageCollection_items = array.filter((a) => a.sys.id === id)[0];
  if (!item || !item?.slug) return;
  let urlSlug: string = "";
  if (item?.isContainer) {
    urlSlug = parentUrl;
  } else {
    if (parentUrl === "") {
      urlSlug = "/";
    } else {
      urlSlug = parentUrl === "/" ? `${parentUrl}${item?.slug}` : `${parentUrl}/${item?.slug}`;
    }
  }

  const children = item?.childrenpagesCollection?.items
    ? item?.childrenpagesCollection?.items?.filter((item: any) => item !== null)
    : ([] as Array<SiteStructureType_pageCollection_items_childrenpagesCollection_items>);
  if (children && children.length) {
    children.forEach(
      (child: SiteStructureType_pageCollection_items_childrenpagesCollection_items) => {
        structureItemChildren.push(getFlatStructure(array, child?.sys?.id, flatStructure, urlSlug));
      },
    );
  }
  if (!item?.isContainer) {
    flatStructure.push({
      slug: item?.slug,
      url: urlSlug === "/start" ? "/" : item?.redirectsTo?.trim() ? item?.redirectsTo : urlSlug,
      name: item?.title,
    });
  }

  return flatStructure;
};

const getSpecialItemUrls = (
  array: Array<URLStructureType_pageCollection_items>,
): UrlStructureItem[] => {
  const specialTypesTypesItemUrls = [];
  const specialTypesTypes = ["newspage", "reportpage", "eventpage"];
  const items = array.filter((a) =>
    specialTypesTypes.includes(a?.content?.__typename?.toLowerCase()),
  );
  if (items && items.length) {
    items.forEach((item: URLStructureType_pageCollection_items) => {
      if (!item || !item?.slug || item?.slug === "anslutna-utbildningsanordnare") return;
      let urlSlug: string = "";
      if (item?.content?.__typename?.toLowerCase() === "newspage") {
        urlSlug = "/om-oss/aktuellt/nyheter/";
      } else if (item?.content?.__typename?.toLowerCase() === "eventpage") {
        urlSlug = "/om-oss/aktuellt/evenemang/";
      } else if (item?.content?.__typename?.toLowerCase() === "reportpage") {
        urlSlug = "/ohalsa-och-arbetsskador/analys-och-statistik/aktuella-statistikrapporter/";
      }

      specialTypesTypesItemUrls.push({
        slug: item?.slug,
        url: item?.redirectsTo?.trim() ? item?.redirectsTo : urlSlug + item?.slug,
        name: item?.title,
      });
    });
  }
  return specialTypesTypesItemUrls;
};
